var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiseAuRebut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    id: "svg6",
    viewBox: "0 0 13.5 13.5",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8a1b61"
    },
    id: "circle2",
    r: 6.75,
    cy: 6.75,
    cx: 6.75
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd"
    },
    id: "path4",
    d: "M 7.9431,6.74995 9.8779,4.8152 c 0.3295,-0.32949 0.3295,-0.86359 0,-1.19308 -0.3291,-0.32949 -0.864,-0.32949 -1.1931,0 L 6.75,5.55687 4.81522,3.62212 c -0.32907,-0.32949 -0.86403,-0.32949 -1.1931,0 -0.32949,0.32949 -0.32949,0.86359 0,1.19308 L 5.5569,6.74995 3.62212,8.6847 c -0.32949,0.3295 -0.32949,0.8636 0,1.1931 0.16454,0.1649 0.38054,0.2472 0.59655,0.2472 0.21601,0 0.43201,-0.0823 0.59655,-0.2472 L 6.75,7.943 8.6848,9.8778 c 0.1645,0.1649 0.3805,0.2472 0.5965,0.2472 0.216,0 0.432,-0.0823 0.5966,-0.2472 0.3295,-0.3295 0.3295,-0.8636 0,-1.1931 z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiseAuRebut);
export default __webpack_public_path__ + "static/media/MiseAuRebut.1d75a684eee946e81e0c0e26af47b5e2.svg";
export { ForwardRef as ReactComponent };